exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".newsletters .newsletter {\n  padding: 0.75rem 1rem;\n  border-top: 2px solid #e3f0f4; }\n  .newsletters .newsletter .item-actions {\n    opacity: 0;\n    transition: all 200ms ease-in; }\n  .newsletters .newsletter:hover {\n    cursor: pointer; }\n    .newsletters .newsletter:hover .item-actions {\n      opacity: 1; }\n  .newsletters .newsletter:hover {\n    background-color: #fcf9f3; }\n  .newsletters .newsletter .icon .fa {\n    font-size: 300%;\n    color: #d1d6db; }\n  .newsletters .newsletter .title {\n    font-weight: bold; }\n  .newsletters .newsletter .content {\n    color: #898a8e;\n    margin-bottom: 1rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/newsletter/newsletters-list/newsletters-list.component.scss
// module id = 407
// module chunks = 0